import { Button, ButtonGroup } from '@mui/material'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { ActionButtonsGroupProps } from '../../types'

export default function ActionButtonsGroup({
    className,
    items,
    variant = "outlined",
    color = 'primary',
    style
}: ActionButtonsGroupProps) {
    return (
        <ButtonGroup variant={variant} color={color} aria-label="contained primary button group" disableElevation className={className} sx={style}>
            {items.filter(i => !i.hide).map((item, idx) => <Button
                key={idx + item.title}
                onClick={item.action}
                title={item.title}
                variant={item.variant}
                color={item.color}
                sx={item.style}
                type={item.type || 'button'}
                startIcon={item.label && item.icon ? <FontAwesomeIcon icon={item.icon} /> : undefined}
            >
                {item.icon && !item.label && <FontAwesomeIcon icon={item.icon} />} {item.label}
            </Button>)}
        </ButtonGroup>
    )
}
